import React, { useState, useEffect } from "react";
import Loader from "react-loader-spinner";
import * as customerActions from "../../Redux/Actions/customer";
import { toastMessage } from "../../utils/toast";
import { getParams } from "../../utils";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { validationError, clearSession } from "../../utils/initiate";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
const UpdateCustomer = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    title: "Mr.",
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    countryCode: "",
    fullName:''
  });

  const dispatch = useDispatch();
  const { t } = useTranslation();

  let params = getParams(window.location.search);
  let id = params.id;

  useEffect(() => {
    setLoading(true);
    customerActions
      .getIndividual(id)
      .then((res) => {
        if (res && res.data) {
          setFormData((preState) => ({
            ...preState,
            ["id"]: res.data.id,
            ["title"]: res.data.title,
            ["firstName"]: res.data.firstName,
            ["lastName"]: res.data.lastName,
            ["email"]: res.data.email,
            ["mobileNumber"]: res.data.mobileNumber,
            ["countryCode"]: res.data.countryCode,
            ['fullName']:res.data.fullName
          }));
        } else {
          toastMessage(
            "error",
            (res && res.message) || `Unable to get the customer info`
          );
        }
        setLoading(false);
      })
      .catch((err) => {
        err.response.status === 401 && clearSession(dispatch, history);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleUpdateUser = () => {
    let payload = { ...formData };
    setButtonLoading(true);
    if (
      formData.title !== "" &&
      formData.firstName !== "" &&
      formData.lastName !== "" &&
      formData.email !== "" &&
      formData.mobileNumber !== "" &&
      formData.countryCode !== ""
    ) {
      customerActions
        .update(payload)
        .then((res) => {
          if (res && res.data) {
            toastMessage("success", `User added successfully`);
            history.push("/customers");
            setFormData({
              id: "",
              title: "Mr.",
              firstName: "",
              lastName: "",
              email: "",
              mobileNumber: "",
              countryCode: "",
            });
          } else {
            toastMessage("error", `Customer added Failed`);
          }
          setButtonLoading(false);
        })
        .catch((err) => {
          setButtonLoading(false);
          err.response.status === 400 &&
            err.response &&
            validationError(err.response);
          err.response.status === 401 && clearSession(dispatch, history);
        });
    } else {
      setButtonLoading(false);
      toastMessage("error", `Enter the correct customer details`);
    }
  };

  const handlePhoneInput = (e, value) => {
    let splitMobile = e?.split(value?.dialCode);
    handleOnChange("countryCode", value?.dialCode);
    handleOnChange("mobileNumber", splitMobile?.[1]);
  };

  const handleOnChange = (field, value) => {
    setFormData((preState) => ({
      ...preState,
      [field]: value,
    }));
  };

  return (
    <div className="container-fluid">
      <div className="my-4">
        <span
          className="card-label font-weight-bolder c-pointer"
          onClick={() => history.push(`/customers`)}
        >
          {t("customersManagement.updateCustomer.customers")}
        </span>
        <span className="card-label font-weight-bolder mx-2">/</span>
        <span className="card-label font-weight-bolder text-dark">{formData.fullName}</span>
      </div>
      <div className="row">
        <div className="col-lg-12 col-xxl-12">
          <div className="card card-stretch">
            <div className="card-header border-0 py-2">
              <h3 className="card-title align-items-start flex-column">
                <span className="card-label font-weight-bolder text-dark">
                  {t("customersManagement.updateCustomer.title")}
                </span>
              </h3>
            </div>
            {loading ? (
              <Loader
                type="ThreeDots"
                color="#ad1a5f"
                height={40}
                width={40}
                style={{ textAlign: "center" }}
              />
            ) : (
              <div className="card-body py-0">
                <div className="form-group fv-plugins-icon-container">
                  <label className="mb-1">
                    {t("customersManagement.addCustomer.customerTitle")}
                  </label>
                  <select
                    className="form-select"
                    value={formData.title}
                    name="title"
                    onChange={(e) => {
                      handleOnChange("title", e.target.value);
                    }}
                  >
                    <option className="font-17" value="Mr.">
                      Mr.
                    </option>
                    <option className="font-17" value="Mrs.">
                      Mrs.
                    </option>
                    <option className="font-17" value="Major.">
                      Major.
                    </option>
                    <option className="font-17" value="Dr.">
                      Dr.
                    </option>
                  </select>{" "}
                </div>
                <div className="form-group fv-plugins-icon-container">
                <label className="mb-1">
                    {t("customersManagement.addCustomer.firstName")}
                  </label>
                  <input
                    placeholder={t(
                      "customersManagement.addCustomer.firstNamePlaceholder"
                    )}
                    type="text"
                    className="form-control"
                    name="firstName"
                    value={formData.firstName}
                    onChange={(e) =>
                      handleOnChange("firstName", e.target.value)
                    }
                  />
                </div>
                <div className="form-group fv-plugins-icon-container">
                <label className="mb-1">
                    {t("customersManagement.addCustomer.lastName")}
                  </label>
                  <input
                    placeholder={t(
                      "customersManagement.addCustomer.lastNamePlaceholder"
                    )}
                    type="text"
                    className="form-control"
                    name="lastName"
                    value={formData.lastName}
                    onChange={(e) => handleOnChange("lastName", e.target.value)}
                  />
                </div>
                <div className="form-group fv-plugins-icon-container">
                <label className="mb-1">
                    {t("customersManagement.addCustomer.email")}
                  </label>
                  <input
                    placeholder={t(
                      "customersManagement.addCustomer.emailPlaceholder"
                    )}
                    type="text"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={(e) => handleOnChange("email", e.target.value)}
                  />
                </div>
                <div className="form-group fv-plugins-icon-container">
                <label className="mb-1">
                    {t("customersManagement.addCustomer.mobileNumber")}
                  </label>
                  <PhoneInput
                    value={formData.countryCode+formData.mobileNumber}
                    country={"ae"}
                    placeholder={t(
                      "customersManagement.addCustomer.mobileNumber"
                    )}
                    onChange={(e, phone) => handlePhoneInput(e, phone)}
                  />
                </div>
                <button
                  disabled={buttonLoading}
                  onClick={handleUpdateUser}
                  type="button"
                  className="d-flex align-items-center btn btn-primary font-weight-bold mb-3"
                >
                  {t("customersManagement.updateCustomer.title")}{" "}
                  {buttonLoading && (
                    <Loader
                      type="Oval"
                      color="#fff"
                      height={20}
                      width={20}
                      style={{ marginLeft: "10px" }}
                    />
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateCustomer;
